module.exports = __webpack_public_path__ + "static/media/Pattern5.cd9c4607.jpg";